export default __webpack_public_path__ + "static/media/bgEventPurchase.31f4b95e.png";